/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderReportsDTO,
  OrderReportsDTOOptional,
  OrderReportsDTOMetaI,
  OrderReportsDTOTrackedI,
} from "./order-reports-dto";
import {
  OrderReportsDTOTracked,
  OrderReportsDTOMeta,
} from "./order-reports-dto";

/**
 *
 * @export
 * @interface OrderReportsResultDTO
 */
export interface OrderReportsResultDTOOptional {
  /**
   *
   * @type {string}
   * @memberof OrderReportsResultDTO
   */
  queueId?: string;
  /**
   *
   * @type {OrderReportsDTO}
   * @memberof OrderReportsResultDTO
   */
  orderReports?: OrderReportsDTOOptional;
}

export interface OrderReportsResultDTO extends OrderReportsResultDTOOptional {
  /**
   *
   * @type {string}
   * @memberof OrderReportsResultDTO
   */
  queueId?: string;
  /**
   *
   * @type {OrderReportsDTO}
   * @memberof OrderReportsResultDTO
   */
  orderReports?: OrderReportsDTO;
}

export interface OrderReportsResultDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof OrderReportsResultDTO
   */
  queueId?: string;
  queueIdIsSet: boolean;
  /**
   *
   * @type {OrderReportsDTO}
   * @memberof OrderReportsResultDTO
   */
  orderReports?: OrderReportsDTOTrackedI;
  orderReportsIsSet: boolean;
}

transformDatesMap.set(
  "OrderReportsResultDTO",
  function (model: OrderReportsResultDTO) {
    const transformDatesorderReports = transformDatesMap.get("OrderReportsDTO");
    if (transformDatesorderReports && model.orderReports) {
      transformDatesorderReports(model.orderReports);
    }
  },
);

export type OrderReportsResultDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  queueId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  orderReports: PropertyMeta<OrderReportsDTOMetaI>;
}>;

export var OrderReportsResultDTOMeta: OrderReportsResultDTOMetaI =
  {} as OrderReportsResultDTOMetaI;
OrderReportsResultDTOMeta = typeMeta("OrderReportsResultDTO", {
  queueId: propertyMeta("queueId", false, false, false, MetaTypesBase.string),
  orderReports: propertyMeta(
    "orderReports",
    false,
    false,
    false,
    OrderReportsDTOMeta,
  ),
});

const metaI = OrderReportsResultDTOMeta;

registerMeta(() => {});

export class OrderReportsResultDTOTracked implements OrderReportsResultDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  queueId__I?: string = undefined;
  queueIdIsSet: boolean = false;
  set queueId(v: undefined | string) {
    if (v !== undefined) {
      this.queueId__I = v;
      this.queueIdIsSet = true;
    } else {
      this.queueId__I = v || undefined;
      this.queueIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get queueId() {
    return this.queueId__I;
  }
  orderReports__I?: OrderReportsDTOTracked = undefined;
  orderReportsIsSet: boolean = false;
  set orderReports(v: undefined | OrderReportsDTOTracked) {
    if (v !== undefined) {
      this.orderReports__I = v;
      this.orderReportsIsSet = true;
    } else {
      this.orderReports__I = v || undefined;
      this.orderReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderReports() {
    return this.orderReports__I;
  }
  constructor(config?: OrderReportsResultDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.orderReports?.setIds();
  }
  assignFrom(
    config: OrderReportsResultDTOOptional,
    options?: AssignOptions,
  ): OrderReportsResultDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.queueId && this.queueIdApplyFilter(optionsRequired.filter)) {
      this.queueId = config.queueId;
      if (optionsRequired.unassign) this.queueIdIsSet = false;
      else this.queueIdIsSet = true;
    }
    if (
      config.orderReports &&
      this.orderReportsApplyFilter(optionsRequired.filter)
    ) {
      this.orderReports = new OrderReportsDTOTracked(
        config.orderReports,
        options,
      );
      if (optionsRequired.unassign) this.orderReportsIsSet = false;
      else this.orderReportsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderReportsResultDTOTrackedI {
    const cloned = {} as OrderReportsResultDTOTrackedI;
    if (
      this.queueIdIsSetDeep() &&
      this.queueIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.queueIdIsSet = true;
      cloned.queueId = this.queueId;
    } else {
      //cloned.queueIdIsSet = false
    }
    if (
      this.orderReportsIsSetDeep() &&
      this.orderReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderReportsIsSet = true;
      cloned.orderReports = this.orderReports?.removeUnset(filter);
    } else {
      //cloned.orderReportsIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderReportsResultDTOTrackedI {
    if (!this.queueIdApplyFilter(filter)) this.queueIdIsSet = false;

    if (!this.orderReportsApplyFilter(filter)) this.orderReportsIsSet = false;
    this.orderReports?.unassignAll(filter);

    return this;
  }
  queueIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsResultDTOMeta.queueId,
      OrderReportsResultDTOMeta,
      this.queueId,
      this,
    );
  }
  queueIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.queueIdIsSet && this.queueIdApplyFilter(filter)) return true;

    return false;
  }
  orderReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderReportsResultDTOMeta.orderReports,
      OrderReportsResultDTOMeta,
      this.orderReports,
      this,
    );
  }
  orderReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderReportsIsSet && this.orderReportsApplyFilter(filter))
      return true;
    return this.orderReports?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.queueIdIsSetDeep(filter)) return true;
    if (this.orderReportsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
